interface ClickLike {
  button?: number;
  metaKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
}

export const isPlainClick = (e: ClickLike) =>
  !e.button && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
